import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import { destroy as removeItemFromCart } from "APP_ROOT/Nav/SaleOrdersCart/actions";
import { addItemToCartAndRefreshList } from "MODULES/SalesOrders/actions";
import {
  ADMIN,
  CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST,
  PERMISSIONS,
  ROLE,
  USER
} from "MODULES/users/constants";
import { ID } from "APP_ROOT/constants";

const CartButton = ({ disabled, item, handleClick, currentUser }) => {
  const isAdmin = currentUser.get(ROLE) === ADMIN;
  const hasPermission = (currentUser.get(PERMISSIONS) || []).includes(
    CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST
  );
  const inCart = !!item.sales_order_cart_id;

  const notDisabled =
    currentUser.get(ID) === item.sales_order_cart_id ||
    isAdmin ||
    hasPermission;

  const removalText = notDisabled ? "Remove From Cart" : "In Cart";
  const text = inCart ? removalText : "Add to Cart";

  const classes = classNames(
    "btn btn-xs btn-hollow",
    classNames({
      "text-muted": inCart,
      "btn-primary": !inCart,
      "btn-default": inCart
    })
  );

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={(inCart && !notDisabled) || disabled}
      className={classes}
    >
      {text}
    </button>
  );
};

CartButton.propTypes = {
  currentUser: PropTypes.shape({}),
  disabled: PropTypes.bool,
  item: PropTypes.shape({
    id: PropTypes.number,
    sales_order_cart_id: PropTypes.number
  }).isRequired,
  handleClick: PropTypes.func.isRequired
};

export default connect(
  state => ({
    currentUser: state.session.get(USER)
  }),
  (dispatch, ownProps) => ({
    handleClick: () =>
      ownProps.item.sales_order_cart_id
        ? dispatch(removeItemFromCart(ownProps.item.id))
        : dispatch(addItemToCartAndRefreshList(ownProps.item.id))
  })
)(CartButton);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/ReserveForSale/CartActionButton.jsx